<script charset="utf-8" src="https://map.qq.com/api/js?v=2.exp&key=NBZBZ-S54HS-5VKOL-6RSRS-AXMDE-4DFDF"></script>
<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">巡逻地点添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="巡逻地点名称" required prop="name">
                                    <el-input v-model="addForm.name" placeholder="请输入巡逻地点名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="24" class="item">
                                <el-col :span="12" class="mapsearch">
                                    <el-input v-model="search" placeholder="请输入搜索地址" @keyup.enter.native="onSearch">
                                        <el-button slot="append" icon="el-icon-search" @click="onSearch">
                                            搜索
                                        </el-button>
                                    </el-input>
                                </el-col>
                                <div id="container"></div>
                            </el-col> -->
                        </el-row>
                        
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import qqmap from "qqmap";

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                floor:null,
                search:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    updateTime:''
                },
                rules:{
                    name:[
                        { required: true, message: '请输入巡逻地点名称', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            // init(){
            //     var that=this
            //     this.$refs.addForm.resetFields();
            //     qqmap.init('NBZBZ-S54HS-5VKOL-6RSRS-AXMDE-4DFDF', function() {
            //     })
            //     var myLatlng = new qq.maps.LatLng(31.82147335256711, 117.2272539138794);
            //     //定义工厂模式函数
            //     var myOptions = {
            //       zoom: 15,               //设置地图缩放级别
            //       center: myLatlng,      //设置中心点样式
            //         mapTypeId: qq.maps.MapTypeId.ROADMAP,  //设置地图样式详情参见MapType
            //         panControl: false,
            //         zoomControlOptions: {
            //             //设置缩放控件的位置为相对左方中间位置对齐.
            //             position: qq.maps.ControlPosition.RIGHT_BOTTOM,
            //             //设置缩放控件样式为仅包含放大缩小两个按钮
            //             style: qq.maps.ZoomControlStyle.DEFAULT
            //         }
            //     }
                
            //     //获取dom元素添加地图信息
            //     var map = new qq.maps.Map(document.getElementById("container"), myOptions);
            //     var marker = new qq.maps.Marker({
            //         position: myLatlng ,
            //         map: map
            //     });

            //      qq.maps.event.addListener(map, 'click', function(event) {
            //         that.addForm.lat = event.latLng.getLat();
            //         that.addForm.lon = event.latLng.getLng();
            //         marker.setPosition(event.latLng);
            //     });
            //     that.geocoder = new qq.maps.Geocoder({
            //         complete: function (result) {
            //             map.setCenter(result.detail.location);
            //             map.setZoom(16)
            //             that.addForm.lat = result.detail.location.getLat();
            //             that.addForm.lon = result.detail.location.getLng();
            //             marker.setPosition(result.detail.location);
            //         }
            //     });
            // },
            // onSearch() {
            //     this.geocoder.getLocation(this.search);
            // },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.updateTime=new Date()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PatrolPoint/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 450px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
                .mapsearch{
                    position: absolute;
                    padding: 10px;
                    z-index: 1000;
                }
            }
            #container{
                width:100%;
                height:400px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
